//
//  Vuex 객체 생성 관리 (2018/06/01 정재윤)
// - multiple Vuex 관리
//

import RootStore from './root'

if (window.vue.getInstance('store') === undefined) {
  let vuex = RootStore.createInstance()

  window.vue.setInstance('store', vuex)
}



// WEBPACK FOOTER //
// ./src/_fdp/core/vuex/index.js